import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Search = () => {
  const [input, setInput] = useState("");
  const navigate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    navigate("searched/" + input);
  };

  return (
    <FormStyle onSubmit={submitHandler}>
      <div>
        <FaSearch />
        <input
          onChange={(e) => setInput(e.target.value)}
          type="text"
          value={input}
        />
      </div>
      {/* <h1>{input}</h1> */}
    </FormStyle>
  );
};

const FormStyle = styled.form`
  margin: 0rem 10rem;

  @media (max-width: 768px) {
    margin: 0rem 6rem;


}

@media (max-width: 480px) {
  margin: 0rem 4rem;

  }

  div {
    width: 100%;
    position: relative;
  }
  input {
    border: none;
    background: linear-gradient(35deg, #7f22b9, #2511df);
    font-size: 1rem;
    color: white;
    padding: 1rem 2.5rem;
    border: none;
    border-radius: 2rem;
    outline: none;
    width: 100%;


  }

  svg {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(100%, -50%);
    color: white;
  }
`;

export default Search;
